import { Navigate, Route, Routes } from "react-router-dom";
import ReactGA from "react-ga4";
import ProtectedRoutes from "./common/components/protected-routes";
import AvailabilityPage from "./pages/availability/availability-page";
import DashboardPage from "./pages/dashboard/dashboard-page";
import HelpPage from "./pages/help/help-page";
import LoginPage from "./pages/login/login-page";
import LogoutPage from "./pages/logout/logout-page";
import ServicePage from "./pages/service/service-page";
import ServicesPage from "./pages/services/services-page";
import { getProperty } from "./utils/config-util";

function AppContainer() {

    // Get gTag from production .env file
    const gTag = getProperty("G_TAG", "");
    // Initialize google analytic for production environment. As gtag will be added for prod config only.
    if (gTag !== "") {
        ReactGA.initialize(gTag);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }

    const returnPath = sessionStorage.getItem("return_path");
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/loggedout" element={<LogoutPage />} />
            <Route path="*" element={<h2>Page Not Found</h2>} />
            <Route element={<ProtectedRoutes />}>
                <Route exact path="/" element={<DashboardPage />} />
                <Route path="/help-and-support" element={<HelpPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:id" element={<ServicePage />} />
                <Route path="/availability" element={<AvailabilityPage />} />
                <Route path="/oauthCallback" element={<Navigate to={returnPath || "/"} />} />
            </Route>
        </Routes>
    );
}

export default AppContainer;
